import { merge } from 'lodash';
import ReactApexChart from 'react-apexcharts';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

// material
import { useTheme, styled } from '@mui/material/styles';
import { Card, CardHeader } from '@mui/material';
// utils
import { fNumber } from '../../../common/utils/formatNumber';
//
import { BaseOptionChart } from '../../charts';
import { useTranslation } from '../../../common/LocalizationProvider';
import ButtonUpgradePro from '../../ButtonUpgradePro';
import { selectAbonnementData } from '../../../createSelectorUtils';

// ----------------------------------------------------------------------

const CHART_HEIGHT = 390;
const LEGEND_HEIGHT = 90;

const ChartWrapperStyle = styled('div')(({ theme }) => ({
  height: CHART_HEIGHT,
  marginTop: theme.spacing(5),
  '& .apexcharts-canvas svg': { height: CHART_HEIGHT },
  '& .apexcharts-canvas svg,.apexcharts-canvas foreignObject': {
    overflow: 'visible'
  },
  '& .apexcharts-legend': {
    height: LEGEND_HEIGHT,
    alignContent: 'center',
    borderTop: `solid 1px ${theme.palette.divider}`,
    top: `calc(${CHART_HEIGHT - LEGEND_HEIGHT}px) !important`
  }
}));

// ----------------------------------------------------------------------

AppTotalPointSummary.propTypes = {
  summary: PropTypes.array
};
export default function AppTotalPointSummary({ summary }) {
  const t = useTranslation();
  const theme = useTheme();
  const abonnement = useSelector(selectAbonnementData);

  const CHART_DATA = [
    summary.reduce((sum, item) => {
      sum += item.pointNewAD;
      return sum;
    }, 0),
    summary.reduce((sum, item) => {
      sum += item.pointTrip;
      return sum;
    }, 0),
    summary.reduce((sum, item) => {
      sum += item.pointAlert;
      return sum;
    }, 0),
    summary.reduce((sum, item) => {
      sum += item.pointLanding;
      return sum;
    }, 0),
    summary.reduce((sum, item) => {
      sum += item.pointPerfectLanding;
      return sum;
    }, 0),
    summary.reduce((sum, item) => {
      sum += item.pointBonus;
      return sum;
    }, 0),
    summary.reduce((sum, item) => {
      sum += item.pointRemarquableTrace;
      return sum;
    }, 0)
  ];

  const chartOptions = merge(BaseOptionChart(), {
    colors: [
      theme.palette.primary.main,
      theme.palette.info.main,
      theme.palette.warning.main,
      theme.palette.error.main
    ],
    labels: [
      t('Point_New_AD'),
      t('Point_Trip'),
      t('Point_Alert'),
      t('Point_Landing'),
      t('Point_Perfect_Landing'),
      t('Point_Bonus'),
      t('Point_Remarquable_Trace')
    ],
    stroke: { colors: [theme.palette.background.paper] },
    legend: { floating: true, horizontalAlign: 'center' },
    dataLabels: { enabled: true, dropShadow: { enabled: false } },
    tooltip: {
      fillSeriesColor: false,
      y: {
        formatter: (item) => fNumber(item),
        title: {
          formatter: (item) => `${item}`
        }
      }
    },
    plotOptions: {
      pie: { donut: { labels: { show: false } } }
    }
  });

  return (
    <Card>
      <CardHeader title={t('Total_Point')} />
      <ChartWrapperStyle
        dir="ltr"
        style={{
          filter: abonnement ? 'none' : 'blur(5px)'
        }}
      >
        <ReactApexChart
          type="pie"
          series={abonnement ? CHART_DATA : [10, 10, 10, 10, 10, 10, 10]}
          options={chartOptions}
          height={330}
        />
      </ChartWrapperStyle>
      {!abonnement && <ButtonUpgradePro />}
    </Card>
  );
}
